import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState, } from 'react';
import { Stack, Popper, } from '@mui/material';
import { getMark, setMarks, getPluginType, useEventPlateId, usePlateEditorRef, usePlateEditorState, select, ToolbarButton, } from '@udecode/plate';
import { useStore } from '@mcn-platform/models';
import { replaceStylesheetGlobals } from '@mcn-platform/converse-lib';
import ColorControl from './common/ColorPickerControl';
const ColorPickerToolbar = ({ keyId, pluginKey, icon, }) => {
    // const [appliedMarks, setAppliedMarks] = useState<any>();
    const eventEditorId = useEventPlateId(keyId);
    // console.log('eventEditorId', eventEditorId);
    const editor = usePlateEditorState(eventEditorId);
    // console.log('editor is', editor);
    const editorRef = usePlateEditorRef(eventEditorId);
    const type = getPluginType(editorRef, pluginKey);
    const [colorSelected, setColorSelected] = useState('#FFFFFF');
    useEffect(() => {
        const selectedColor = editorRef && getMark(editorRef, type);
        // console.log('useEffect called:', fontSizeValue, editor);
        if (editor?.selection) {
            setColorSelected(selectedColor);
        }
    }, [colorSelected, editor?.selection, editorRef, type]);
    const store = useStore();
    const { currentPortal: portal } = store;
    const fetchGlobalColor = (colorName) => {
        if (!colorName || !portal.stylesheet) {
            return colorName;
        }
        return replaceStylesheetGlobals(portal.stylesheet, colorName);
    };
    const regex = /[0-9A-Fa-f]{6}/g;
    const validatorOfHexColor = (inputValue) => {
        if (!inputValue)
            return inputValue;
        return inputValue.match(regex) ? inputValue : fetchGlobalColor(inputValue);
    };
    const update = (colorId) => {
        setColorSelected(colorId);
        const validatedId = validatorOfHexColor(colorId);
        if (editorRef && editor && editor.selection) {
            select(editorRef, editor.selection);
            setMarks(editor, { [type]: validatedId });
        }
    };
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'popper-Color' : undefined;
    const onClickMethod = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    const onCloseMethod = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    return (_jsxs(Stack, { children: [_jsx(ToolbarButton, { icon: icon, onClick: onClickMethod }), _jsx(Popper, { id: id, open: open, anchorEl: anchorEl, placement: "bottom-start", style: {
                    zIndex: 10,
                    boxShadow: 'rgba(0, 0, 0, 0.15) 0px 0px 0px 1px, rgba(0, 0, 0, 0.15) 0px 8px 16px',
                    borderRadius: '8px',
                    marginBottom: '10px',
                }, children: _jsx(ColorControl
                // label="Color"
                , { 
                    // label="Color"
                    value: colorSelected, onChange: update, onCloseMethod: onCloseMethod }) })] }));
};
ColorPickerToolbar.defaultProps = {
    keyId: '',
};
export default ColorPickerToolbar;
//# sourceMappingURL=ColorPickerToolbar.js.map